export default "__VITE_ASSET__0039813c__"